/**
 * Tracks the last seen store id so sagas can react only to real store switches,
 * without fragile "skip the first dispatch" module-level flags.
 */
export const createStoreIdChangeTracker = () => {
  let lastKnownStoreId: string | null | undefined;

  return {
    /** Align tracker with the current store (e.g. when a saga mounts). */
    sync: (storeId?: string | null) => {
      if (storeId) {
        lastKnownStoreId = storeId;
      }
    },
    /** Returns true when storeId is a new selection; updates the tracker. */
    hasChanged: (storeId?: string | null): boolean => {
      if (!storeId || storeId === lastKnownStoreId) {
        return false;
      }
      lastKnownStoreId = storeId;
      return true;
    },
  };
};
